import React, { useState } from 'react';

const NoticesInput = ({
  handleChange, notices, refetch, biddingNotice, setBiddingNotice
}) => {
  const [newNotice, setNewNotice] = useState('')
  if (!notices) { return null; }

  const handleKeyPress = (e) => {
    if ('Enter' === e.nativeEvent.key) {
      handleChange(newNotice);
      setBiddingNotice(newNotice);
      setNewNotice('');
    }
  };

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: 10 }}>
      <span
        style={{
          paddingTop: '7px',
          font: '14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        }}
      >
        Update:
      </span>
      <input
        value={newNotice}
        onChange={e => setNewNotice(e.target.value)}
        style={{ width: '100%', height: 26, borderRadius: '5px' }}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
};

export default NoticesInput;
